// extracted by mini-css-extract-plugin
export default {"search-container":"SearchBar_search-container__VXOSo","search-input":"SearchBar_search-input__2ctcU","search-button":"SearchBar_search-button__N-nEU"};